// a function that generates a unique id using the execution timestamp, a random number and a random letter from A-Z
const generateUniqueId = () => {
  let timestamp = Date.now().toString(36);
  let randomNum = Math.floor(Math.random() * 1000000).toString(36);
  let randomLetter = String.fromCharCode(65 + Math.floor(Math.random() * 26));
  return `${timestamp}-${randomNum}-${randomLetter}`;
};

export const pushEvent = data => {
  if (!data) return;

  if (!window.dataLayer) {
    window.dataLayer = [];
    console.warn('Data Layer not found, creating instance...');
  }

  // Enhanced Ecommerce: window.dataLayer persists and GTM merges the
  // `ecommerce` object across successive pushes, so keys from a prior event
  // (impressions, add, checkout, purchase, etc.) would otherwise leak into the
  // next event's payload. Push `ecommerce: null` first to clear the merged
  // model so each event only carries its own ecommerce data. (Google documents
  // this reset for GA4; the same dataLayer merge applies to this UA-style EE.)
  if (data.ecommerce) {
    window.dataLayer.push({ ecommerce: null });
  }

  window.dataLayer.push({ eventId: generateUniqueId(), ...data });
};
